import React from 'react';
import { MapPin, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
export function ProjectGallery() {
  const projects = [{
    title: 'New Build Lighting Upgrade',
    suburb: 'Southern River',
    desc: 'Complete lighting transformation — replaced builder-standard fittings with premium downlights, pendants, and LED strip lighting throughout.',
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85f82e?auto=format&fit=crop&q=80&w=800',
    type: 'New Build'
  }, {
    title: 'Split System AC Installation',
    suburb: 'Harrisdale',
    desc: 'Supply and installation of a new split system air conditioner for a family home, including dedicated circuit.',
    image: 'https://images.unsplash.com/photo-1631545806609-35d4ae440431?auto=format&fit=crop&q=80&w=800',
    type: 'Air Conditioning'
  }, {
    title: 'Commercial Fit-Out',
    suburb: 'Maddington',
    desc: 'Full electrical fit-out for a commercial workshop including three-phase power, LED lighting, and switchboard upgrade.',
    image: 'https://images.unsplash.com/photo-1621905252507-b35492cc74b4?auto=format&fit=crop&q=80&w=800',
    type: 'Commercial'
  }, {
    title: 'Pendant & Feature Lighting',
    suburb: 'Gosnells',
    desc: 'Designer pendant lighting installation over kitchen island and dining area, with dimmer controls.',
    image: 'https://images.unsplash.com/photo-1524484485831-a92ffc0de03f?auto=format&fit=crop&q=80&w=800',
    type: 'Lighting'
  }, {
    title: 'Switchboard Upgrade',
    suburb: 'Thornlie',
    desc: 'Full switchboard replacement to meet current safety standards and support additional circuits for a home renovation.',
    image: 'https://images.unsplash.com/photo-1581092921461-eab62e97a780?auto=format&fit=crop&q=80&w=800',
    type: 'Residential'
  }, {
    title: 'Emergency Fault Finding',
    suburb: 'Huntingdale',
    desc: 'Located and repaired a complex wiring fault causing intermittent power outages in a family home.',
    image: 'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?auto=format&fit=crop&q=80&w=800',
    type: 'Emergency'
  }];
  return <section className="py-20 lg:py-28 bg-white" data-id="element-399">
      <div className="max-w-7xl mx-auto px-4" data-id="element-400">
        <div className="flex flex-col md:flex-row justify-between items-end mb-12 gap-6" data-id="element-401">
          <div className="max-w-2xl" data-id="element-402">
            <span className="text-orange font-bold tracking-wider uppercase text-sm mb-3 block" data-id="element-403">
              Our Work
            </span>
            <h2 className="text-4xl md:text-5xl font-heading font-extrabold text-navy mb-4 tracking-tighter" data-id="element-404">
              Recent Projects Across Perth's South
            </h2>
            <p className="text-lg text-slate leading-relaxed" data-id="element-405">
              Take a look at some of our recent electrical installations,
              upgrades, and repairs.
            </p>
          </div>
          <a href="#quote" className="hidden md:inline-flex items-center gap-2 text-orange font-extrabold hover:text-orange-600 transition-colors" data-id="element-406">
            Start Your Project <ArrowRight className="w-5 h-5" data-id="element-407" />
          </a>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-id="element-408">
          {projects.map((project, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="group bg-white rounded-2xl overflow-hidden border border-gray-100 shadow-sm hover:shadow-xl transition-all duration-300 flex flex-col" data-id="element-409">
              <div className="relative h-56 overflow-hidden" data-id="element-410">
                <div className="absolute inset-0 bg-navy/20 group-hover:bg-transparent transition-colors z-10" data-id="element-411"></div>
                <img src={project.image} alt={project.title} className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500" data-id="element-412" />
                <div className="absolute top-4 left-4 z-20 bg-white/90 backdrop-blur-sm px-3 py-1.5 rounded-lg text-xs font-bold text-navy shadow-sm" data-id="element-413">
                  {project.type}
                </div>
              </div>
              <div className="p-6 flex flex-col flex-grow" data-id="element-414">
                <div className="flex items-center gap-1.5 text-orange text-sm font-bold mb-3" data-id="element-415">
                  <MapPin className="w-4 h-4" data-id="element-416" />
                  {project.suburb}
                </div>
                <h3 className="text-xl font-heading font-extrabold text-navy mb-2" data-id="element-417">
                  {project.title}
                </h3>
                <p className="text-slate text-sm leading-relaxed mb-6 flex-grow" data-id="element-418">
                  {project.desc}
                </p>
                <a href="#" className="inline-flex items-center gap-1.5 text-sm font-extrabold text-navy group-hover:text-orange transition-colors mt-auto" data-id="element-419">
                  View Details <ArrowRight className="w-4 h-4" data-id="element-420" />
                </a>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}